<template>
  <BaseModal :modal-name="name" max-width="max-w-2xl">
    <p class="mb-10 font-medium text-darkestGray">
      {{ $t('collection_points.invalid_home_service_for_kid') }}
    </p>
  </BaseModal>
</template>

<script setup>
const name = 'unableToPickHomeServiceModal'
</script>
